export const blueprintFragment = /* GraphQL */ `
  fragment blueprintItem on Blueprint {
    id
    projectBlueprintsId
    sections(limit: 1000) {
      items {
        id
        name
        type
        translations {
          items {
            id
            lang
            label
          }
        }
        shapes(
          limit: 1000
          filter: {
            or: [{ type: { eq: RECTANGLE } }, { type: { eq: FREEFORM } }]
          }
        ) {
          items {
            id
            name
            type
          }
        }
      }
    }
  }
`
